import '../styles/lbdo-main.scss';
import { docReady } from './helpers/docReady';
import { typeStyles } from './sections/image-hero';
import ListeningPlayers from './sections/featured-listening';
import { marqueeSection } from './sections/marquee';
docReady(() => {
    typeStyles();
    ListeningPlayers.init();
    marqueeSection();
});
